// extracted by mini-css-extract-plugin
export default {"figure":"qHUJB","rating":"hd_h3","ellipsis":"z3Z5e","title":"e9v7V","overflow":"mxdhY"};